/**
 * Brand assets URLs.
 *
 * Os ficheiros são servidos localmente a partir de `frontend/public/`,
 * evitando dependências de CDNs externos em produção.
 *
 * - LOGO_URL          → marca quadrada (app icon "me Safa"), usada em
 *                       contentores quadrados (topbar, sidebars, logins).
 * - LOGO_WORDMARK_URL → logótipo horizontal completo com slogan.
 * - LOGO_MARK_URL     → símbolo isolado (sem texto), ideal para fundos escuros.
 */
export const LOGO_URL = "/favicon.webp";
export const LOGO_WORDMARK_URL = "/logo.webp";
export const LOGO_MARK_URL = "/favicon-light.webp";

export const HERO_IMG_1 =
    "https://images.pexels.com/photos/6457556/pexels-photo-6457556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const HERO_IMG_2 =
    "https://images.pexels.com/photos/2422289/pexels-photo-2422289.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const SOCIAL_PROOF_IMG =
    "https://images.pexels.com/photos/30848031/pexels-photo-30848031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
